import { USER_ROLES } from 'utils/constants';

export const PERMISSIONS = {
  /** Top-level Modules */
  ACCESS_SETTINGS_MODULE: 'accessSettingsModule',
  ACCESS_TEAMS_MODULE: 'accessTeamsModule',
  ACCESS_DASHBOARDS_MODULE: 'accessDashboardsModule',
  ACCESS_INSIGHTS_MODULE: 'accessInsightsModule',
  ACCESS_LEARNING_SCHEDULE_MODULE: 'accessLearningScheduleModule',
  ACCESS_BUDGETS_MODULE: 'accessBudgetsModule',
  /** Settings Page Tabs */
  ACCESS_USERS_SETTINGS: 'accessUsersSettings',
  /** Configurations */
  ACCESS_INTAKE_SETTINGS: 'accessIntakeSettings',
  ACCESS_PROJECT_SETTINGS: 'accessProjectSettings',
  ACCESS_FIELDS_SETTINGS: 'accessFieldsSettings',
  ACCESS_INTAKE_GENERAL: 'accessIntakeGeneral',
  ACCESS_INTAKE_REQUEST_FORMS: 'accessIntakeRequestForms',
  ACCESS_FINANCIAL_SETTINGS: 'accessFinancialSettings',
  /** Teams Settings */
  ACCESS_LEARNING_TEAMS: 'accessLearningTeams',
  ACCESS_BUSINESS_TEAMS: 'accessBusinessTeams',
  ACCESS_VENDORS: 'accessVendors',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

/**
 * Role-to-permissions mapping.
 * Mirrors the backend ROLE_CAPABILITIES_MAP pattern from
 * capabilityDrivenPermissions.ts — each role lists the
 * permissions it is granted.
 *
 * Admin is intentionally omitted — admins have all permissions
 * by default (see usePermissions hook).
 */
export const ROLE_PERMISSIONS_MAP: Partial<
  Record<UserRole, readonly Permission[]>
> = {
  [USER_ROLES.POWER_USER]: [
    PERMISSIONS.ACCESS_SETTINGS_MODULE,
    PERMISSIONS.ACCESS_INTAKE_SETTINGS,
    PERMISSIONS.ACCESS_INTAKE_REQUEST_FORMS,
    PERMISSIONS.ACCESS_PROJECT_SETTINGS,
    PERMISSIONS.ACCESS_FIELDS_SETTINGS,
    PERMISSIONS.ACCESS_INSIGHTS_MODULE,
    PERMISSIONS.ACCESS_TEAMS_MODULE,
    PERMISSIONS.ACCESS_DASHBOARDS_MODULE,
    PERMISSIONS.ACCESS_LEARNING_SCHEDULE_MODULE,
    PERMISSIONS.ACCESS_VENDORS,
  ],
};
